module.exports = __webpack_public_path__ + "img/ExistingUserAnd1.a2ecff61.png";